import type { PaymentDepositAccount } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { PaymentDepositAccountInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type PaymentDepositAccountFormModel = AutoGeneratorForFormModel<
	PaymentDepositAccountInputZodSchemaType,
	ExcludeKeys,
	PaymentDepositAccount
>;
